import React from 'react'
import ReactDOM from 'react-dom'
import './styles.css'
import App from './App'
import { GlobalProvider } from './context/globalContext'
ReactDOM.render(
  <GlobalProvider>
    <App />
  </GlobalProvider>,
  document.getElementById('root')
)
